import { useState, useEffect } from "react";
import { useReport } from "../../hooks/useReport";
import { embedDashboard } from "@superset-ui/embedded-sdk/lib";

const SUPERSET_HOST = "https://superset.pcrm.dev.sntechlabs.com";

const DASHBOARD_ID = "3de5dfb3-587c-414e-a98f-925d08dc89e2";

export const useReportViewModel = () => {
  const {
    fetchGuestToken,
    loading: tokenLoading,
    error: tokenError,
  } = useReport();
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");
  const [selectedFilters, setSelectedFilters] = useState({});

  const REFRESH_THRESHOLD_MS = 300000;
  let guestToken;
  let tokenExpirationTimeout;

  const refreshGuestToken = async (filters = {}) => {
    try {
      const token = await fetchGuestToken(3);
      guestToken = token;

      if (tokenExpirationTimeout) {
        clearTimeout(tokenExpirationTimeout);
      }

      tokenExpirationTimeout = setTimeout(
        () => refreshGuestToken(filters),
        REFRESH_THRESHOLD_MS * 0.9
      );
      return guestToken;
    } catch (error) {
      console.error("Error refreshing token:", error);
      const errorMessage = error?.message || "Failed to refresh token";
      setError(errorMessage);
      setTimeout(() => refreshGuestToken(filters), 5000);
      return null;
    }
  };

  const embedDashboardForRole = (mountPoint, filters = {}) => {
    setIsLoading(true);
    setError("");
    setSelectedFilters(filters);

    refreshGuestToken(filters)
      .then((token) => {
        console.log("token", token);
        embedDashboard({
          id: DASHBOARD_ID,
          supersetDomain: SUPERSET_HOST,
          mountPoint: mountPoint,
          fetchGuestToken: () => token,
          dashboardUiConfig: {
            hideTitle: true,
            hideTab: true,
            hideChartControls: true,
            filters: {
              visible: false,
              expanded: false,
            },
          },
        });

        if (mountPoint.children[0]) {
          mountPoint.children[0].width = "100%";
          mountPoint.children[0].height = "100%";
          mountPoint.children[0].frameBorder = "0";
          mountPoint.children[0].style.border = "none";
          mountPoint.children[0].allow = "fullscreen";
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.error("Error embedding dashboard:", error);
        const errorMessage = error?.message || "Failed to embed dashboard";
        setError(errorMessage);
        setIsLoading(false);
      });
  };

  // Initialize token on mount
  useEffect(() => {
    const initializeToken = async () => {
      try {
        const token = await refreshGuestToken();
        if (token) {
          console.log("Initial token obtained successfully");
        }
      } catch (error) {
        console.error("Error obtaining initial token:", error);
      }
    };

    initializeToken();

    return () => {
      if (tokenExpirationTimeout) {
        clearTimeout(tokenExpirationTimeout);
      }
    };
  }, []);

  return {
    embedDashboardForRole,
    isLoading: isLoading || tokenLoading,
    error: error || tokenError?.message || "",
    selectedFilters,
    setSelectedFilters,
  };
};
